import { render, staticRenderFns } from "./closeTicket.vue?vue&type=template&id=cefd4b76&scoped=true&"
import script from "./closeTicket.vue?vue&type=script&lang=js&"
export * from "./closeTicket.vue?vue&type=script&lang=js&"
import style0 from "./closeTicket.vue?vue&type=style&index=0&id=cefd4b76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cefd4b76",
  null
  
)

export default component.exports